import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Update({ open, onClose, item, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    adresse: '',
    telephone: '',
    description: '',
    statut: true,
    user_id: user?.id,
    ville: '',
    pays: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!item) return;
    setFormData({
      nom: item.nom ?? '',
      adresse: item.adresse ?? '',
      telephone: item.telephone ?? '',
      description: item.description ?? '',
      statut: item.statut === 'actif',
      user_id: user?.id,
      ville: item.ville ?? '',
      pays: item.pays ?? '',
    });
    setErrors({});
  }, [item, user?.id]);

  if (!open || !item) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...formData,
      statut: formData.statut ? 'actif' : 'inactif',
    };

    try {
      const token = localStorage.getItem('token');
      await axios.put(`${APP_API_URL}/fournisseurs/${item.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: 'Les modifications ont été enregistrées.',
        timer: 2000,
        showConfirmButton: false,
      });

      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'enregistrement.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title={`Modifier — ${item.nom}`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            form={`update-supplier-form-${item.id}`}
            className="duo-btn duo-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id={`update-supplier-form-${item.id}`} onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor={`supplier-nom-${item.id}`} className="duo-form-label">
            Nom du fournisseur *
          </label>
          <input
            type="text"
            className="duo-input"
            id={`supplier-nom-${item.id}`}
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor={`supplier-adresse-${item.id}`} className="duo-form-label">
            Adresse
          </label>
          <input
            type="text"
            className="duo-input"
            id={`supplier-adresse-${item.id}`}
            name="adresse"
            value={formData.adresse}
            onChange={handleChange}
          />
          {errors.adresse && <p className="text-danger small mt-1 mb-0">{errors.adresse[0]}</p>}
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor={`supplier-pays-${item.id}`} className="duo-form-label">
                Pays
              </label>
              <input
                type="text"
                className="duo-input"
                id={`supplier-pays-${item.id}`}
                name="pays"
                value={formData.pays}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group mb-0">
              <label htmlFor={`supplier-ville-${item.id}`} className="duo-form-label">
                Ville
              </label>
              <input
                type="text"
                className="duo-input"
                id={`supplier-ville-${item.id}`}
                name="ville"
                value={formData.ville}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </form>
    </DuoModal>
  );
}
